// @flow

export default Object.freeze({
  ADD_ANGI_LEADS_PRO_TO_SERVICE_PROVIDER_CACHE: 'office-app/ADD_ANGI_LEADS_PRO_TO_SERVICE_PROVIDER_CACHE',

  GET_CURRENT_USERS_SERVICE_PROVIDERS: 'office-app/GET_CURRENT_USERS_SERVICE_PROVIDERS',
  GET_CURRENT_USERS_SERVICE_PROVIDERS_ERROR: 'office-app/GET_CURRENT_USERS_SERVICE_PROVIDERS_ERROR',
  GET_CURRENT_USERS_SERVICE_PROVIDERS_START: 'office-app/GET_CURRENT_USERS_SERVICE_PROVIDERS_START',
  GET_CURRENT_USERS_SERVICE_PROVIDERS_SUCCESS: 'office-app/GET_CURRENT_USERS_SERVICE_PROVIDERS_SUCCESS',
  GET_CURRENT_USERS_SERVICE_PROVIDERS_RESET: 'office-app/GET_CURRENT_USERS_SERVICE_PROVIDERS_RESET',

  GET_ADS_SERVICE_PROVIDER: 'office-app/GET_ADS_SERVICE_PROVIDER',
  GET_ADS_SERVICE_PROVIDER_ERROR: 'office-app/GET_ADS_SERVICE_PROVIDER_ERROR',
  GET_ADS_SERVICE_PROVIDER_START: 'office-app/GET_ADS_SERVICE_PROVIDER_START',
  GET_ADS_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_ADS_SERVICE_PROVIDER_SUCCESS',
  GET_ADS_SERVICE_PROVIDER_RESET: 'office-app/GET_ADS_SERVICE_PROVIDER_RESET',

  GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS: 'office-app/GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS',
  GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_ERROR: 'office-app/GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_ERROR',
  GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_START: 'office-app/GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_START',
  GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_SUCCESS: 'office-app/GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_SUCCESS',
  GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_RESET: 'office-app/GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS_RESET',

  GET_SERVICE_PROVIDER: 'office-app/GET_SERVICE_PROVIDER',
  GET_SERVICE_PROVIDER_ERROR: 'office-app/GET_SERVICE_PROVIDER_ERROR',
  GET_SERVICE_PROVIDER_START: 'office-app/GET_SERVICE_PROVIDER_START',
  GET_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_SERVICE_PROVIDER_SUCCESS',
  GET_SERVICE_PROVIDER_RESET: 'office-app/GET_SERVICE_PROVIDER_RESET',

  GET_SERVICE_PROVIDER_UNREAD_COUNTS: 'office-app/GET_SERVICE_PROVIDER_UNREAD_COUNTS',
  GET_SERVICE_PROVIDER_UNREAD_COUNTS_ERROR: 'office-app/GET_SERVICE_PROVIDER_UNREAD_COUNTS_ERROR',
  GET_SERVICE_PROVIDER_UNREAD_COUNTS_START: 'office-app/GET_SERVICE_PROVIDER_UNREAD_COUNTS_START',
  GET_SERVICE_PROVIDER_UNREAD_COUNTS_SUCCESS: 'office-app/GET_SERVICE_PROVIDER_UNREAD_COUNTS_SUCCESS',
  GET_SERVICE_PROVIDER_UNREAD_COUNTS_RESET: 'office-app/GET_SERVICE_PROVIDER_UNREAD_COUNTS_RESET',

  GET_SERVICE_PROVIDER_METRICS: 'office-app/GET_SERVICE_PROVIDER_METRICS',
  GET_SERVICE_PROVIDER_METRICS_ERROR: 'office-app/GET_SERVICE_PROVIDER_METRICS_ERROR',
  GET_SERVICE_PROVIDER_METRICS_START: 'office-app/GET_SERVICE_PROVIDER_METRICS_START',
  GET_SERVICE_PROVIDER_METRICS_SUCCESS: 'office-app/GET_SERVICE_PROVIDER_METRICS_SUCCESS',
  GET_SERVICE_PROVIDER_METRICS_RESET: 'office-app/GET_SERVICE_PROVIDER_METRICS_RESET',

  GET_SERVICE_PROVIDER_ACCOUNT_OWNER: 'office-app/GET_SERVICE_PROVIDER_ACCOUNT_OWNER',
  GET_SERVICE_PROVIDER_ACCOUNT_OWNER_ERROR: 'office-app/GET_SERVICE_PROVIDER_ACCOUNT_OWNER_ERROR',
  GET_SERVICE_PROVIDER_ACCOUNT_OWNER_START: 'office-app/GET_SERVICE_PROVIDER_ACCOUNT_OWNER_START',
  GET_SERVICE_PROVIDER_ACCOUNT_OWNER_SUCCESS: 'office-app/GET_SERVICE_PROVIDER_ACCOUNT_OWNER_SUCCESS',
  GET_SERVICE_PROVIDER_ACCOUNT_OWNER_RESET: 'office-app/GET_SERVICE_PROVIDER_ACCOUNT_OWNER_RESET',

  UPDATE_SERVICE_PROVIDER_ID: 'office-app/UPDATE_SERVICE_PROVIDER_ID',

  GET_LEAF_SLUG: 'office-app/GET_LEAF_SLUG',
  GET_LEAF_SLUG_START: 'office-app/GET_LEAF_SLUG_START',
  GET_LEAF_SLUG_SUCCESS: 'office-app/GET_LEAF_SLUG_SUCCESS',

  GET_LEAD_SERVICE_PROVIDER: 'office-app/GET_LEAD_SERVICE_PROVIDER',
  GET_LEAD_SERVICE_PROVIDER_ERROR: 'office-app/GET_LEAD_SERVICE_PROVIDER_ERROR',
  GET_LEAD_SERVICE_PROVIDER_START: 'office-app/GET_LEAD_SERVICE_PROVIDER_START',
  GET_LEAD_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_LEAD_SERVICE_PROVIDER_SUCCESS',
  GET_LEAD_SERVICE_PROVIDER_RESET: 'office-app/GET_LEAD_SERVICE_PROVIDER_RESET',

  GET_ADS_SERVICE_PROVIDER_INFO: 'office-app/GET_ADS_SERVICE_PROVIDER_INFO',
  GET_ADS_SERVICE_PROVIDER_INFO_ERROR: 'office-app/GET_ADS_SERVICE_PROVIDER_INFO_ERROR',
  GET_ADS_SERVICE_PROVIDER_INFO_START: 'office-app/GET_ADS_SERVICE_PROVIDER_INFO_START',
  GET_ADS_SERVICE_PROVIDER_INFO_SUCCESS: 'office-app/GET_ADS_SERVICE_PROVIDER_INFO_SUCCESS',
  GET_ADS_SERVICE_PROVIDER_INFO_RESET: 'office-app/GET_ADS_SERVICE_PROVIDER_INFO_RESET',

  GET_SP_PRODUCT_PACKAGE: 'GET_SP_PRODUCT_PACKAGE',
  GET_SP_PRODUCT_PACKAGE_START: 'GET_SP_PRODUCT_PACKAGE_START',
  GET_SP_PRODUCT_PACKAGE_SUCCESS: 'GET_SP_PRODUCT_PACKAGE_SUCCESS',
  GET_SP_PRODUCT_PACKAGE_ERROR: 'GET_SP_PRODUCT_PACKAGE_ERROR',

  GET_PRO_PRODUCT_PACKAGE: 'GET_PRO_PRODUCT_PACKAGE',
  GET_PRO_PRODUCT_PACKAGE_START: 'GET_PRO_PRODUCT_PACKAGE_START',
  GET_PRO_PRODUCT_PACKAGE_SUCCESS: 'GET_PRO_PRODUCT_PACKAGE_SUCCESS',
  GET_PRO_PRODUCT_PACKAGE_ERROR: 'GET_PRO_PRODUCT_PACKAGE_ERROR',
});



// WEBPACK FOOTER //
// ./src/app/common/serviceProvider/serviceProviderActionKeys.js